import styled from "styled-components";

const DesktopViewContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  @media (min-width: 1025px) {
    margin: 0;
    padding: 0;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
`;

const TabletWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    height: 100%;
    overflow-y: auto;
    flex: 1;
  }
  @media (min-width: 1025px) {
    position: relative;
    background-color: #ffffff;
    border-radius: 10px;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

const TabletScreen = styled.div`
  @media (max-width: 1024px) {
    height: 100%;
  }
  @media (min-width: 1025px) {
    display: flex;
    flex-direction: column;
    width: 768px;
    height: calc(95vh - 50px);
    position: relative;
    overflow: hidden;
    & > div {
      height: 100%;
    }
    #content-button-image-language {
      height: auto !important;
      #button-image-language {
        position: absolute !important;
      }
    }
    .sectionContent {
      height: calc(100% - 100px) !important;
      overflow-x: hidden;
      overflow-y: auto;
      padding-bottom: 0 !important;
    }
    nav {
      position: sticky !important;
    }

    #bottom-bar-link {
      position: absolute !important;
    }
  }
`;

export { DesktopViewContainer, TabletWrapper, TabletScreen };
